import clsx from 'clsx';

import type { SanityHeroNewsletter } from '#/lib/sanity/queries/sections';

import { BasicText } from './BasicText';
import { FormEmailCapture } from './FormEmailCapture';
import {
  formatHeadline,
  getHeadlineHighlightClass,
  Headline,
} from './Headline';
import { Media } from './Media';

export function HeroNewsletter(props: SanityHeroNewsletter) {
  const highlightClass = getHeadlineHighlightClass({
    background: props.background,
    foreground: props.foreground,
  });
  return (
    <div
      className={clsx('p-main pb-40 m:pb-100', {
        'mt-[calc(var(--header-height)*-1)] pt-[calc(var(--header-height)+5rem)]':
          props.sectionIndex === 0,
        'pt-30': props.sectionIndex !== 0,
      })}
      style={{
        background: props.background ?? undefined,
        color: props.foreground ?? undefined,
      }}
    >
      <div className="mx-auto max-w-1235 gap-x-20 m:flex">
        <div className="flex-1">
          <Headline
            value={props.headline}
            variant={2}
            highlightClass={highlightClass}
            className="mb-10 m:mb-25"
          />
          {props.bodyCopy ? (
            <p className="text-body max-w-[480px]">
              {formatHeadline(props.bodyCopy, highlightClass)}
            </p>
          ) : null}
          <div className="form">
            <FormEmailCapture
              formTitle={'Hero Newsletter'}
              trackingEventProperties={props.trackingEventProperties}
              className="mt-35 max-w-[480px]"
              emailInputPlaceholder={props.emailInputPlaceholder}
              submitButtonLabel={props.submitButtonLabel}
              trackingEventName={props.trackingEventName}
              hubspotCampaignId={props.hubspotCampaignId}
              hubspotConvertingFormType={props.hubspotConvertingFormType}
              hubspotEmailSubscriptionIds={props.hubspotEmailSubscriptionIds}
              confirmation={props.confirmation}
              variant="hero"
            />
            <BasicText
              className="legal-text mt-30 max-w-[480px] text-grayscale-05"
              value={props.legalText ?? []}
            />
          </div>
        </div>
        <div className="media mt-30 flex-1 m:mt-0">
          <Media
            media={props.media}
            sizes={['100vw', { m: '50vw', l: '620px' }]}
          />
        </div>
      </div>
    </div>
  );
}
